import React from 'react';
import { getTimelineWidth } from '../../common/utils/timeline.tsx';
import ChartHeader from './chart-header/view';
import ColumnsOverlay from './columns-overlay';
import HeaderCells from './header-cells';
import Items from './items';
import Chart, { type APIProps } from './view';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default ({ timelineDefaultPosition, ...props }: APIProps) => {
	const { timelineMode, timelineDuration } = props;

	/* The consumer of the table only needs to understand relative values - it knows durations, not pixels.
	 * For convenience, we convert the value to the tables absolute domain value and pass it down.
	 * 1px offset is to account for the column borders.
	 */
	const absoluteTimelinePosition =
		timelineDefaultPosition * getTimelineWidth(timelineMode, timelineDuration) + 1;

	return (
		<Chart
			{...props}
			timelineDefaultPosition={absoluteTimelinePosition}
			ChartHeader={ChartHeader}
			HeaderCells={HeaderCells}
			ColumnsOverlay={ColumnsOverlay}
			Items={Items}
		/>
	);
};

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export type { APIProps };
